import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FilterCommunicationService } from '../../../../../../../core/services/filter-communication.service';
import { EventService } from '../../../../../../../shared/services/event.service';
import {
  CONFIG_BASE_DATE_RANGEPICKER,
  SORT_DIRECTION,
} from '../../../../../../../core/constants/constants';
import {
  columnsTableList,
  bonusTypes,
} from '../../../../../../../shared/data/bonus/balance-bonus/constants';
import {
  MOVEMENT_CLASSES,
  STATE_SP_CLASSES,
  movementType,
} from '../../../../../../../shared/data/suscriptions-payments/constants';
import { SubscriptionPaymentService } from '../../../../../../../core/services/subscription-payment.service';
import moment from 'moment';
import { formatAmount } from '../../../../../../../core/utils/format-numeric.utils';
import Swal from 'sweetalert2';
import { StateService } from '../../../../../../../core/services/state.service';
import { selectAuth } from '../../../../../../../core/state/auth/auth.selector';
import { Store } from '@ngrx/store';
import { selectScreen } from '../../../../../../../core/state/screen/screen.selectors';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../../../../../core/services/user.service';
import { Subscription } from 'rxjs';
import { PAYMENTS_BUTTON_PERMISSIONS } from '../../../../../../../shared/data/config/constants-buttons';
import {
  Permission,
  MainPermission,
} from '../../../../../../../core/interfaces/permision.interface';
import { DynamicModalService } from '../../../../../../../core/services/dynamic-modal.service';
import { EditSpComponent } from '../../forms/edit-sp/edit-sp.component';
import { RepeatedBankVouchersModalComponent } from '../../forms/repeated-bank-vouchers-modal/repeated-bank-vouchers-modal.component';
import { User } from '../../../../../../../core/interfaces/user.interface';
import {
  SubscriptionPaymentListItem,
  SubscriptionPaymentQueryFilters,
  SubscriptionPaymentState,
  SubscriptionPaymentTableItem,
} from '../../../../../../../core/interfaces/subscription-payment.interface';

interface ListSpProfile extends Pick<User, 'idusuario' | 'id_rol'> {
  rol?: {
    permisos_principales: MainPermission[];
  };
}

@Component({
  selector: 'app-list-sp-table',
  templateUrl: './list-sp-table.component.html',
  styleUrl: './list-sp-table.component.scss',
})
export class ListSpTableComponent implements OnInit, OnDestroy {
  private readonly repeatedVouchersModalTitle = 'Comprobantes repetidos';
  public isLoading: boolean = false;
  public isExporting: boolean = false;

  public bonusData: SubscriptionPaymentTableItem[] = [];
  public paginatedBonusData: SubscriptionPaymentTableItem[] = [];
  public columnsTable = columnsTableList;
  public totalDolares: string = '';
  public totalSoles: string = '';
  public states: SubscriptionPaymentState[] = [];
  public actualIndex!: number;
  public actualItem: string | null = null;
  public cardExpanded: boolean[] = [];
  public subMenuItem: SubscriptionPaymentTableItem | null = null;
  public isMobile: boolean = false;
  public token!: string;
  public SORT_DIRECTION = SORT_DIRECTION;
  public PAYMENTS_BUTTON_PERMISSIONS = PAYMENTS_BUTTON_PERMISSIONS;

  public collectionSize: number = 0;
  public page: number = 1;
  public limit: number = 10;
  public sortColumn: string | null = null;
  public sortDirection: string | null = null;

  public selectedFilter: SubscriptionPaymentQueryFilters | null = null;
  public defaultFilter: SubscriptionPaymentQueryFilters | null = null;
  public startDate = CONFIG_BASE_DATE_RANGEPICKER.initialRange[0];
  public endDate = CONFIG_BASE_DATE_RANGEPICKER.initialRange[1];
  public subscribe: Subscription = new Subscription();

  public bonusTypes = bonusTypes;

  public profile$ = this.store.select(selectAuth);
  public profile: ListSpProfile | null = null;
  public rol!: number;

  public isMobile$ = this.store.select(selectScreen);
  public isMobileRedux!: boolean;
  public isRepeatedVouchersViewerMinimized: boolean = false;

  constructor(
    private _filterCommunicationService: FilterCommunicationService,
    private eventService: EventService,
    private spService: SubscriptionPaymentService,
    private stateService: StateService,
    private store: Store,
    private router: Router,
    private activedRouter: ActivatedRoute,
    private _userService: UserService,
    private dynamicModal: DynamicModalService,
  ) {}

  async ngOnInit(): Promise<void> {
    const fullUrl = this.router.url;
    this.isMobile = fullUrl.includes('/mobile');
    this.isMobile$.subscribe((isMobile) => {
      this.isMobileRedux = isMobile;
    });
    this.columnsTable = this.isMobile
      ? columnsTableList.filter((column) => column.name !== 'Acciones')
      : columnsTableList;
    if (this.isMobile) {
      await this.loadTokenLogged();
    } else {
      await this.loadProfileLogged();
    }
    this.getDataFromFilter();
    this.listenRepeatedVouchersModalState();
    this.getStatesSp();
  }

  async loadProfileLogged(): Promise<void> {
    await new Promise<void>((resolve, reject) => {
      this.profile$.subscribe({
        next: (res: ListSpProfile) => {
          if (res.idusuario !== -1) {
            this.profile = res;
            this.rol = res.id_rol;
            this.columnsTable = [2, 10].includes(this.rol)
              ? this.columnsTable.filter((column) => column.name !== 'Acciones')
              : this.columnsTable;
            resolve();
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  }
  async loadTokenLogged(): Promise<void> {
    await new Promise<void>((resolve, reject) => {
      this.activedRouter.params.subscribe((params) => {
        this.token = params['token'];
        this._userService.getUserByTokenApp(this.token).subscribe({
          next: (res) => {
            if (res.data.idusuario) {
              this.profile = res.data;
              resolve();
            } else {
              reject(new Error('No user id found'));
            }
          },
          error: (err) => {
            reject(err);
          },
        });
      });
    });
  }
  getData(): void {
    this.isLoading = true;
    this.defaultFilter = this.selectedFilter
      ? this.selectedFilter
      : {
          type_user: '0',
          date_star: moment(this.startDate).format('YYYY-MM-DD HH:mm:ss'),
          date_end: moment(this.endDate).format('YYYY-MM-DD 23:59:59'),
        };
    const filterWithSorting = {
      ...this.defaultFilter,
      ...(this.sortColumn &&
        this.sortDirection && {
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection,
        }),
    };
    this.spService
      .getAllSp(this.page, this.limit, filterWithSorting)
      .subscribe((res) => {
        const response = res.data;
        this.isLoading = false;
        this.totalDolares = response.totalMontoSummary.Ecuador
          ? formatAmount(Number(response.totalMontoSummary.Ecuador), 'EC')
          : '$ 0';
        this.totalSoles = response.totalMontoSummary.Peru
          ? formatAmount(Number(response.totalMontoSummary.Peru), 'PE')
          : 'S/ 0';
        this.bonusData = response.data.map(
          (item: SubscriptionPaymentListItem) => {
            return {
              ...this.formatSpData(item),
              movementTypeLabel: this.getMovementType(item.id_movimiento),
            };
          },
        );
        this.collectionSize = response.totalCount;
        // The API clamps oversized page sizes, so the totals must be computed
        // from the limit it actually applied, never from the requested one.
        if (response.limit && response.limit !== this.limit) {
          this.limit = response.limit;
        }
      });
  }

  onSort(columnValue: string | undefined) {
    const valueToSort = columnValue ?? '';
    if (this.sortColumn === valueToSort) {
      this.sortDirection =
        this.sortDirection === SORT_DIRECTION.ASC
          ? SORT_DIRECTION.DESC
          : SORT_DIRECTION.ASC;
    } else {
      this.sortColumn = valueToSort;
      this.sortDirection = SORT_DIRECTION.ASC;
    }
    this.page = 1;
    this.getData();
  }

  getMovementType(movmentType: number): string {
    const type = movementType.find((t) => Number(t.value) === movmentType);
    return type ? type.label : 'Desconocido';
  }

  getMovementClass(type: number): string {
    return MOVEMENT_CLASSES[type] || '';
  }

  openRepeatedVouchersModal(): void {
    this.dynamicModal.openModal(
      RepeatedBankVouchersModalComponent,
      this.repeatedVouchersModalTitle,
      'lg',
      false,
      {
        currentFilter: this.selectedFilter,
      },
    );
  }

  toggleRepeatedVouchersViewer(): void {
    if (this.isRepeatedVouchersViewerMinimized) {
      this.dynamicModal.closeModal();
      return;
    }

    this.openRepeatedVouchersModal();
  }

  getMovementIconClass(type: number): string {
    return this.getMovementIconClassFromTypes(type) || '';
  }

  getMovementIconClassFromTypes(type: number): string {
    const MOVEMENT_ICON_CLASSES: Record<number, string> = {
      1: 'fas fa-credit-card',
      2: 'fas fa-money-bill',
    };
    return MOVEMENT_ICON_CLASSES[type] || '';
  }

  getMovementTypeLabel(type: number): string {
    const typeObj = movementType.find((t) => Number(t.value) === type);
    return typeObj ? typeObj.label : 'Desconocido';
  }

  getStatesSp(): void {
    this.stateService.geatAllDataSp().subscribe((response) => {
      this.states = response.data.filter(
        (state: SubscriptionPaymentState) => state.idestado !== 13,
      );
    });
  }

  formatSpData(item: SubscriptionPaymentListItem): SubscriptionPaymentTableItem {
    const monto = formatAmount(
      Number(item.monto),
      item.id_pais === 1 ? 'EC' : 'PE',
    );

    return {
      ...item,
      monto: monto,
      movementTypeLabel: this.getMovementType(item.id_movimiento),
    };
  }

  getDataFromFilter(): void {
    this.subscribe.add(
      this._filterCommunicationService.currentFilter.subscribe(
        (filter: SubscriptionPaymentQueryFilters | null) => {
          if (this.isMobile) {
            if (filter) {
              this.selectedFilter = filter;
              this.page = 1;
              this.getData();
            }
          } else {
            this.selectedFilter = filter;
            this.page = 1;
            this.getData();
          }
        },
      ),
    );
  }

  ngOnDestroy(): void {
    this.subscribe.unsubscribe();
    this._filterCommunicationService.resetFilter();
  }

  private listenRepeatedVouchersModalState(): void {
    this.subscribe.add(
      this.dynamicModal.modalStateChanged.subscribe((state) => {
        if (state.title !== this.repeatedVouchersModalTitle) {
          return;
        }

        this.isRepeatedVouchersViewerMinimized =
          state.isOpen && state.isMinimized;
      }),
    );
  }

  reloadTable(): void {
    this.isLoading = true;
    this.page = 1;
    this.sortColumn = null;
    this.sortDirection = null;
    this.getData();
  }
  setStatus(
    idabonos_pagos: number,
    id_estado: number,
    usuario_updated_id: number,
  ): void {
    Swal.fire({
      title: '¿Estás seguro que  quieres cambiar el estado?',
      text: 'No podrás revertir esto!',
      icon: 'warning',
      iconColor: '#8C98A1',
      showCancelButton: true,
      confirmButtonColor: '#54BA4A',
      cancelButtonColor: '#5A6268',
      confirmButtonText: 'Si, cambiar!',
      cancelButtonText: 'No, cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.spService
          .setState(idabonos_pagos, id_estado, usuario_updated_id)
          .subscribe((response) => {
            Swal.fire({
              title: 'Estado actualizado 👌!',
              text: 'El estado fue actualizado correctamente.',
              icon: 'success',
            });
          });
      }
    });
  }

  exportToExcel(): void {
    this.isExporting = true;
    this.spService.exportAllSp(this.defaultFilter ?? {}).subscribe({
      next: (response) => {
        this.downloadBlobResponse(response);
        this.isExporting = false;
      },
      error: () => {
        this.isExporting = false;
        Swal.fire({
          title: 'No se pudo generar el reporte',
          text: 'Intentá nuevamente en unos minutos.',
          icon: 'error',
        });
      },
    });
  }

  private downloadBlobResponse(response: HttpResponse<Blob>): void {
    const blob = response.body;

    if (!blob) {
      Swal.fire({
        title: 'La descarga no contiene archivo',
        icon: 'error',
      });
      return;
    }

    const fileName =
      this.extractFileNameFromResponse(response) ?? 'abonos-pagos-reporte.xlsx';
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = objectUrl;
    link.download = fileName;
    link.click();

    window.URL.revokeObjectURL(objectUrl);
  }

  private extractFileNameFromResponse(
    response: HttpResponse<Blob>,
  ): string | null {
    const contentDisposition =
      response.headers.get('content-disposition') ??
      response.headers.get('Content-Disposition');

    if (!contentDisposition) {
      return null;
    }

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
      return decodeURIComponent(utf8Match[1]);
    }

    const simpleMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
    return simpleMatch?.[1] ?? null;
  }

  onPageChange(page: number): void {
    this.page = page;
    this.getData();
  }

  onLimitChange(limit: number): void {
    this.page = 1;
    this.limit = limit;
    this.getData();
  }

  getStateClasses(state: number): { text: string; classes: string | string[] | Record<string, boolean> } {
    return STATE_SP_CLASSES[state] || { text: '', classes: {} };
  }

  showMenu: boolean = false;
  showSubMenu: boolean = false;
  toggleMenu(index: number, item: SubscriptionPaymentTableItem): void {
    this.showMenu = !this.showMenu;
    if (this.showMenu) {
      this.actualIndex = index;
      this.actualItem = item.observacion ?? null;
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'auto';
    }
  }
  expandCard(index: number): void {
    this.cardExpanded[index] = !this.cardExpanded[index];
  }
  closeMenu(): void {
    this.showMenu = false;
    this.showSubMenu = false;
    document.body.style.overflowY = 'auto';
  }
  openSubMenu(item: SubscriptionPaymentTableItem): void {
    this.subMenuItem = item;
    this.showMenu = false;
    this.showSubMenu = true;
  }
  openObservationSubMenu(): void {
    this.showMenu = false;
    this.showSubMenu = true;
  }
  closeSubMenu(): void {
    this.showMenu = true;
    this.showSubMenu = false;
  }

  getAgentOrAccountLabel(item: SubscriptionPaymentTableItem): string {
    return (
      item.agent?.usuario ??
      item.accountingAccount?.name ??
      item.cuenta?.nombre_cuenta ??
      'Sin Agente'
    );
  }

  getReferenceLabel(
    value: { usuario?: string | null; banco?: string | null } | null | undefined,
    field: 'usuario' | 'banco',
  ): string {
    return value?.[field] ?? '';
  }

  getColumnText(
    item: SubscriptionPaymentTableItem,
    columnValue?: string,
  ): string {
    switch (columnValue) {
      case 'fecha':
        return this.formatDateValue(item.fecha);
      case 'n_comprobante':
        return item.n_comprobante ?? '';
      case 'monto':
        return item.monto;
      case 'movementTypeLabel':
        return item.movementTypeLabel;
      case 'observacion':
        return item.observacion ?? '';
      case 'fecha_bancaria':
        return this.formatDateValue(item.fecha_bancaria);
      default:
        return '';
    }
  }

  private formatDateValue(value?: string | Date | null): string {
    return value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '';
  }

  hasPermission(permissionId: number): boolean {
    return (
      this.profile?.rol?.permisos_principales?.some(
        (mainPermission: MainPermission) =>
          mainPermission.permisos.some(
            (permission: Permission) => permission.id === permissionId,
          ),
      ) ?? false
    );
  }
  openReverseCw(item: SubscriptionPaymentTableItem): void {
    this.dynamicModal.openModal(
      EditSpComponent,
      'Editar Lista Abonos y Pagos',
      'xl',
      false,
      { item: item, filter: this.selectedFilter },
    );
  }
}
